export const OPEN_CRYPTA_GROUP_FAMILY_EDITOR = 'OPEN_CRYPTA_GROUP_FAMILY_EDITOR';
export type OPEN_CRYPTA_GROUP_FAMILY_EDITOR = typeof OPEN_CRYPTA_GROUP_FAMILY_EDITOR;

export interface OpenCryptaGroupFamilyEditor {
    type: OPEN_CRYPTA_GROUP_FAMILY_EDITOR;
    id: string;
    itemsId: string[];
}

export function openCryptaGroupFamilyEditor(id: string, itemsId: string[]): OpenCryptaGroupFamilyEditor {
    return {
        type: OPEN_CRYPTA_GROUP_FAMILY_EDITOR,
        id,
        itemsId
    };
}

export const CLOSE_CRYPTA_GROUP_FAMILY_EDITOR = 'CLOSE_CRYPTA_GROUP_FAMILY_EDITOR';
export type CLOSE_CRYPTA_GROUP_FAMILY_EDITOR = typeof CLOSE_CRYPTA_GROUP_FAMILY_EDITOR;

export interface CloseCryptaGroupFamilyEditor {
    type: CLOSE_CRYPTA_GROUP_FAMILY_EDITOR;
    id: string;
    itemsId?: string[];
}

export function closeCryptaGroupFamilyEditor(id: string, itemsId?: string[]): CloseCryptaGroupFamilyEditor {
    return {
        type: CLOSE_CRYPTA_GROUP_FAMILY_EDITOR,
        id,
        itemsId
    };
}

export const RESET_CRYPTA_GROUP_FAMILY_EDITOR = 'RESET_CRYPTA_GROUP_FAMILY_EDITOR';
export type RESET_CRYPTA_GROUP_FAMILY_EDITOR = typeof RESET_CRYPTA_GROUP_FAMILY_EDITOR;

export interface ResetCryptaGroupFamilyEditor {
    type: RESET_CRYPTA_GROUP_FAMILY_EDITOR;
    id: string;
}

export function resetCryptaGroupFamilyEditor(id: string): ResetCryptaGroupFamilyEditor {
    return {
        type: RESET_CRYPTA_GROUP_FAMILY_EDITOR,
        id
    };
}

export const CHANGE_ITEM_CRYPTA_GROUP_FAMILY = 'CHANGE_ITEM_CRYPTA_GROUP_FAMILY';
export type CHANGE_ITEM_CRYPTA_GROUP_FAMILY = typeof CHANGE_ITEM_CRYPTA_GROUP_FAMILY;

export interface ChangeItemCryptaGroupFamily {
    type: CHANGE_ITEM_CRYPTA_GROUP_FAMILY;
    id: string;
    itemId: string;
}

export function changeItemCryptaGroupFamily(id: string, itemId: string): ChangeItemCryptaGroupFamily {
    return {
        type: CHANGE_ITEM_CRYPTA_GROUP_FAMILY,
        id,
        itemId
    };
}

export type CryptaGroupFamilyEditorAction =
    | CloseCryptaGroupFamilyEditor
    | ResetCryptaGroupFamilyEditor
    | OpenCryptaGroupFamilyEditor
    | ChangeItemCryptaGroupFamily;
